import isEmpty from 'lodash/isEmpty';

/*
    Методы нормализации данных (РИГИС остаточной нефтенасыщенности) для отрисовки в:
    - список (отвечает за видимость исследований)
    - шапку в виде небольших колонок-исследований
*/
export const normalize = {
    toList(data) {
        if (!data) return [];

        return data.map(dataItem => {
            const { stratumVersionId, stratumVersionDate, stratumVersionDescription } = dataItem;

            return {
                stratumId: stratumVersionId,
                date: stratumVersionDate,
                description: stratumVersionDescription,
            };
        });
    },
    toHead(data) {
        return this.toList(data);
    },
};

export function prepareResearch(data) {
    return data.reduce((acc, it) => {
        acc[it.stratumVersionId] = true;
        return acc;
    }, {});
}

/*
    Метод, который фильтрует данные после вызова Promise.all.
    Отбрасывает все ошибки и возвращает данные в виде, удобном для добавления в состояние.
*/
export function filterMultiResponse(multiResponse) {
    const filteredMultiResponse = multiResponse
        .filter(response => response.status === 'fulfilled')
        .map(successResponse => successResponse.value);

    return isEmpty(filteredMultiResponse) ? null : filteredMultiResponse;
}
